var React = require('react');
var ReactDOM = require('react-dom');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var Reflux = require('reflux');
var Shopify = require('./shopify');
var Utils = require('./utils');
var Breadcrumb = require('./breadcrumb');
var ProductRow = require('./product-row');
var HeaderPage = require('./header-page');
var HeaderFull = require('./header-full-m');
var ScrollToTop = require('./scroll-to-top');
var ScreenWid = require('./stores/screen-wid-store');

var ColorSwatch = React.createClass({
  
  selected: false,

  componentDidMount: function() {
    if ("#ffffff" == this.props.color) {
      jQuery(this.refs.swatchInner).css("border", "1px solid #908d89");
    }
    jQuery(this.refs.swatchInner).css("background-color", this.props.color);
  },

  handleClick: function(e) {
    jQuery(this.refs.swatch).toggleClass('selected');
    this.selected = !this.selected;
    this.props.changed(this.selected, this.props.color);
  },

  unselect: function() {
    this.selected = false;
    jQuery(this.refs.swatch).removeClass('selected');
  },

  render: function() {
    return <div ref="swatch" onClick={this.handleClick} className="color-swatch">
        <div ref="swatchInner" className="color-swatch-inner"></div>
      </div> 
  }
});

var ColorSwatches = React.createClass({

  selectedColors: [],
  swatches: [],

  getInitialState: function() {
    var sws = [];

    for (var color in CMS.colors) {
      var cs = <ColorSwatch color={color} changed={this.handleChange}
                            ref={function(s){ 
                                   if (s) { this.swatches.push(s); }
                                }.bind(this)}
                            key={color} />;
      sws.push(cs);
    }
    return {swatches: sws};
  },

  handleChange: function(added, color) {
    if (added) {
      this.selectedColors.push(color);
    } else {
      this.selectedColors.splice(this.selectedColors.indexOf(color), 1);
    }
    var selected = _.reduce(this.selectedColors, function(result, color) {
      return result += (result.length ? ", " : "") + CMS.colors[color];
    }, "");
    this.props.changed(selected.length ? selected.replace(/ /g, '').split(',') : []);
  },

  clearAll: function() {
    this.swatches.map(function(swatch) {
      if (swatch && swatch.unselect) swatch.unselect();
    });
    this.selectedColors = [];
    this.props.changed(this.selectedColors);
  },

  render: function() {
    return <div className="color-swatches">
               {this.state.swatches}
           </div>
  }
});

var SWFilterMobile = React.createClass({

  getInitialState: function() {
    return { items: [] }
  },

  handleClick: function(e) {
    jQuery(e.target).parent().find('li').removeClass('active');
    jQuery(e.target).addClass('active');
    this.props.itemChange(jQuery(e.target)[0].innerHTML);
  },

  setItems: function(items) {
    this.setState({ items: items.map(function(item) {
                               return <li onClick={this.handleClick}
                                          key={item}>{item}
                                      </li> }.bind(this)) });
  },

  clearAll: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.ul)).find('li').removeClass('active');
  },

  render: function() {
    return <div ref="sizeFilterSM" className="visible-xs-block">
               <p>{this.props.title}</p>
               <ul ref="ul">
                   {this.state.items}
               </ul>
           </div>
  }
});

var FilterDiv = React.createClass({
  
  heels: [],
  colors: [],
  size: "",
  width: "",
  price: { lowerBound: 0,
           upperBound: 0 },

  getInitialState: function() {

    return { sizes: [],
             sizesSM: [] }
  },

  componentDidMount: function() {
    this.refs.priceFilterSM.setItems(this.generatePriceRangesMobile());
  },

  setSizes: function(sizes) {
    var sorted = _.sortBy(sizes, function(size) {
                      if (size.substring(size.length - 1) == '-'){
                        var strValue = size.substring(0, size.length - 1);
                        return parseInt(strValue) + 0.5;
                      } else {
                        return parseInt(size);
                      }
                 });
    this.setState({ sizes: sorted.map(function(size){
                               return <option name={size} value={size} key={size}>{size}
                                      </option> }) });
    this.refs.sizeFilterSM.setItems(sizes);
  },

  setWidthes: function(widthes) {
    this.setState({ widthes: widthes.map(function(width){
                                 return <option name={width} value={width} key={width}>{width}
                                        </option> }) });
    this.refs.widthFilterSM.setItems(widthes);
  },

  generatePriceRanges: function() {
    return _.reduce(CMS.priceBps, function(acc, bp) {
                                    var lb, ub;

                                    if (acc.length == CMS.priceBps.length) {
                                      lb = bp;
                                      ub = 0;
                                    } else {
                                      lb = bp;
                                      ub = CMS.priceBps[acc.length];
                                    }
                                    acc.push(<option name={lb + "-" + ub}
                                                     value={lb + "-" + ub}
                                                     key={lb + "-" + ub}>
                                                 {0 == ub ? "Above $" + lb : "$" + lb + " - $" + ub}
                                             </option>);
                                    return acc;
                                  }, [<option name={"<" + CMS.priceBps[0]} value={"<" + CMS.priceBps[0]} 
                                              key={CMS.priceBps[0]}>
                                          {"Below $" + CMS.priceBps[0]}
                                      </option>]);
  },

  generatePriceRangesMobile: function() {
    return _.reduce(CMS.priceBps, function(acc, bp) {
                                    var lb, ub;

                                    if (acc.length == CMS.priceBps.length) {
                                      lb = bp;
                                      ub = 0;
                                    } else {
                                      lb = bp;
                                      ub = CMS.priceBps[acc.length];
                                    }
                                    acc.push(0 == ub ? "Above $" + lb : "$" + lb + " - $" + ub);
                                    return acc;
                                  }, ["Below $" + CMS.priceBps[0]]);
  },
  handleColorChange: function(colors) {
    this.colors = colors;
    this.notifyChange();
  },

  handleHeelChange: function(e) {
    this.heels = [jQuery(e.target).val()];
    this.notifyChange();   
  },

  handleHeelChangeSM: function(e) {
    if (jQuery(e.target).is(":checked")) {
      this.heels.push(e.target.value);
    } else {
      this.heels.splice(this.heels.indexOf(e.target.value), 1);
    }
    this.notifyChange();
  },

  handleSizeChange: function(e) {
    this.size = e.target.value;
    this.notifyChange();
  },

  handleSizeChangeSM: function(size) {
    this.size = size;
    this.notifyChange();
  },

  handleWidthChange: function(e) {
    this.width = e.target.value;
    this.notifyChange();
  },

  handleWidthChangeSM: function(wid) {
    this.width = wid;
    this.notifyChange();
  },

  handlePriceChange: function(e) {
    var strPrices = e.target.value;
    var lb, ub;

    if (strPrices.indexOf('<') >= 0) {
      lb = 0;
      ub = parseInt(strPrices.substring(1));
    } else if (strPrices.indexOf('>') >= 0) {
      lb = parseInt(strPrices.substring(1));
      ub = 0;
    } else {
      lb = parseInt(strPrices.substring(0, strPrices.indexOf('-')));
      ub = parseInt(strPrices.substring(strPrices.indexOf('-') + 1));
    }
    this.price = { lowerBound: lb, upperBound: ub };
    this.notifyChange();
  },

  handlePriceChangeSM: function(strPrices) {
    var lb, ub;

    if (strPrices.indexOf('Below $') >= 0) {
      lb = 0;
      ub = parseInt(strPrices.substring('Below $'.length));
    } else if (strPrices.indexOf('Above $') >= 0) {
      lb = parseInt(strPrices.substring('Above $'.length));
      ub = 0;
    } else {
      lb = parseInt(strPrices.substring(1, strPrices.indexOf(' - ')));
      ub = parseInt(strPrices.substring(strPrices.indexOf(' - $') + 4));         
    }
    this.price = { lowerBound: lb, upperBound: ub };
    this.notifyChange();
    this.notifyChange();
  },

  notifyChange: function() {
    this.props.changed({ heels: this.heels,
                         colors: this.colors,
                         size: this.size,
                         width: this.width,
                         price: this.price });
  },

  clearAll: function() {
    this.heels = [];
    this.colors = [];
    this.size = "";
    this.width = "";
    this.price.lowerBound = 0;
    this.price.upperBound = 0;
    jQuery(this.refs.cbLow).prop('checked', false);
    jQuery(this.refs.cbMid).prop('checked', false);
    jQuery(this.refs.cbHi).prop('checked', false);
    this.refs.colorSwatches.clearAll();
    this.refs.heels.selectedIndex = 0;
    jQuery(ReactDOM.findDOMNode(this.refs.heels)).change();
    this.refs.size.selectedIndex = 0;
    this.refs.sizeFilterSM.clearAll();
    this.refs.widthFilterSM.clearAll();
    this.refs.priceFilterSM.clearAll();
    jQuery(ReactDOM.findDOMNode(this.refs.size)).change();
    this.refs.width.selectedIndex = 0;
    jQuery(ReactDOM.findDOMNode(this.refs.width)).change();
    this.refs.price.selectedIndex = 0;
    jQuery(ReactDOM.findDOMNode(this.refs.price)).change();
    this.notifyChange();
  },

  closeFilter: function(e) {
    jQuery('#filter-div .for-border').slideUp();
    jQuery(ReactDOM.findDOMNode(this.refs.btnClose)).text('FILTERS');
    var top = jQuery('#filter-div').offset().top - jQuery('.navbar-header').height();
    jQuery('html, body').animate({scrollTop: top}, 300);
  },

  toggleFilter: function(e) {
    jQuery('#filter-div .for-border').slideToggle(function() {
      var text = jQuery('#filter-div .for-border').is(':visible')? 'X CLOSE FILTERS' : 'FILTERS';
      jQuery(e.target).text(text);
    }.bind(this));
  },

  render: function() {
    return <div id="filter-div">                   
            <div ref="btnClose" id="mobile-filter-header" className="visible-xs-block"
                 onClick={this.toggleFilter}>FILTERS</div>
            <div className="for-border">
                <div className="filter hidden-xs" id="filter-by">
                    <div id="filter-by-inner">FILTER BY</div>
                </div>
                <div className="filter visible-xs filter-heel">
                    <label className="checkbox-label"><input type="checkbox" value="LOW" ref="cbLow" onChange={this.handleHeelChangeSM}/><span className="styled-checkbox"></span>LOW HEEL</label>
                    <label className="checkbox-label"><input type="checkbox" value="MID" ref="cbMid" onChange={this.handleHeelChangeSM}/><span className="styled-checkbox"></span>MED HEEL</label>
                    <label className="checkbox-label"><input type="checkbox" value="HIGH" ref="cbHi" onChange={this.handleHeelChangeSM}/><span className="styled-checkbox"></span>HIGH HEEL</label>
                </div>
                <div className="filter" id="filter-color">
                    <div id="filter-color-inner">
                        <p ref="colorTitle" className="visible-xs-block">COLOUR:</p>
                        <ColorSwatches ref="colorSwatches" changed={this.handleColorChange} />
                    </div>
                </div>
                <div className="filter filter-heel hidden-xs">
                    <div className="styled-select" ref="widthFilter">
                        <div className="select-default">HEEL</div>
                        <select ref="heels" onChange={this.handleHeelChange} defaultValue="">
                          <option value="" disabled>HEEL</option>
                          <option value="LOW" name="LOW">LOW</option>
                          <option value="MID" name="MID">MID</option>
                          <option value="HIGH" name="HIGH">HIGH</option>
                        </select>
                    </div>
                </div>
                <div className="filter" id="filter-size">
                    <div className="styled-select hidden-xs" ref="sizeFilter">
                        <div className="select-default">SIZE</div>
                        <select ref="size" onChange={this.handleSizeChange} defaultValue="">
                          <option value="" disabled>SIZE</option>
                          {this.state.sizes}
                        </select>
                    </div>
                    <SWFilterMobile ref="sizeFilterSM" itemChange={this.handleSizeChangeSM}
                                    title={"SIZE:"} />
                </div>
                <div className="filter" id="filter-width">
                    <div className="styled-select hidden-xs" ref="widthFilter">
                        <div className="select-default">WIDTH</div>
                        <select ref="width" onChange={this.handleWidthChange} defaultValue="">
                          <option value="" disabled>WIDTH</option>
                          {this.state.widthes}
                        </select>
                    </div>
                    <SWFilterMobile ref="widthFilterSM" itemChange={this.handleWidthChangeSM}
                                    title={"WIDTH:"} />
                </div>
                <div className="filter" id="filter-price">
                    <div className="styled-select hidden-xs" ref="priceFilter">
                        <div className="select-default">PRICE</div>
                        <select ref="price" onChange={this.handlePriceChange} defaultValue="">
                          <option value="" disabled>PRICE</option>
                          {this.generatePriceRanges()}
                        </select>
                    </div>
                    <SWFilterMobile ref="priceFilterSM" itemChange={this.handlePriceChangeSM}
                                    title={"PRICE:"} />
                </div>
                <button onClick={this.closeFilter} className="visible-xs-block btn btn-primary"
                        id="filter-submit">SUBMIT</button>
                <div className="filter" id="filter-reset">
                    <a onClick={this.clearAll} role="button">CLEAR FILTERS</a>
                </div>
            </div>
      </div>
  }
});

module.exports = React.createClass({
	
  mixins: [ ScrollToTop ],

  products: [],
  curRemaining: [],
  collection: "",
  forBrand: false,
  headerFull: null,
  collectionTitle: "",
  collectionImage: "",
  menus: [],
  sizes: [],
  widthes: [],
  PRODUCT_PER_BATCH: 12,
  allProductsGot: false,
  curDisplaySet: [],
  curFilters: null,
  unmouned: false,
  showAllWhenLoaded: false,
  backFromProd: false,
  prodBackFrom: "",

  getInitialState: function() {
    var headerFull = null;
    var genderPage = CMS[this.props.params.gender.toLowerCase()];
    this.collection = this.props.params.coll;
    this.backFromProd = 0 == this.props.prevRoute.indexOf('/products/');
    if (this.backFromProd) {
      this.prodBackFrom = this.props.prevRoute.substring('/products/'.length);
    }
    this.prodBackFrom

    if (genderPage.promo1 != this.collection && genderPage.promo2 != this.collection &&
        genderPage.promo3 != this.collection && genderPage.promo4 != this.collection &&
        genderPage.promo5 != this.collection && genderPage.promo6 != this.collection) {
      headerFull = <HeaderFull ref={function(el) { 
                                      this.headerFull = el; 
                                   }.bind(this)}
                               gender={this.props.params.gender}
                               menus={genderPage.categories} />
    }      
  	return { collPrefix: "",
  		       collTitle: "",
             collImage: "",
             collDesc: "",
             headerFull: headerFull,
             products: [] };
  },

  componentDidMount: function() {
  	Shopify.getCollection(this.collection,
                          this.collectionGot,
                          this.firstBatchGot);
  	Shopify.getCollectionInfo(this.collection, this.collectionInfoGot);
    //this.scrollToTop('collection-page');
    _.map(AllPageClass, function(cl) {
      jQuery('body').removeClass(cl);
    });
    jQuery('body').addClass('collection-page');
    var genderPage = CMS[this.props.params.gender.toLowerCase()];
    
    if (genderPage.promo1 == this.collection || genderPage.promo2 == this.collection ||
        genderPage.promo3 == this.collection || genderPage.promo4 == this.collection ||
        genderPage.promo5 == this.collection || genderPage.promo6 == this.collection) {
      jQuery(ReactDOM.findDOMNode(this.refs.filter)).css('display', 'none');
      jQuery(ReactDOM.findDOMNode(this.refs.bcMobile)).removeClass("hide");
      jQuery(ReactDOM.findDOMNode(this.refs.bcMobile)).addClass("visible-xs-block");
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.headerPage)).addClass("desktop");
      jQuery(ReactDOM.findDOMNode(this.refs.bcMobile)).addClass("hide");
      jQuery(ReactDOM.findDOMNode(this.refs.bcMobile)).removeClass("visible-xs-block");
    }
  },

  componentWillUnmount: function() {
    this.unmouned = true;
  },

  firstBatchGot: function(firstBatch, allDone) {
    if (this.unmouned) return;

    if (allDone || !firstBatch.length) {
      this.allProductsGot = true;
      if (!firstBatch.length) {
        this.setState({ products: <div className="empty-msg">
                                    <p>We’re sorry to say that, at the moment, we do not have any of these in stock. But we should soon.</p>
                                  </div> });
        return;
      }
    }

    this.products = firstBatch;

    if (allDone && this.backFromProd) {
      this.setProductDivs(this.products);
    } else {
      var first9 = _.take(firstBatch, this.PRODUCT_PER_BATCH);
      this.curRemaining = firstBatch.slice(this.PRODUCT_PER_BATCH);

      this.setProductDivs(first9);
    }

    this.sizes = _.reduce(this.products, function(result, prod) {
      return _.reduce(prod.variants, function(res, variant) {
        if (res.indexOf(variant.option2) < 0) res.push(variant.option2);
        return res;
      }, result);
    }, this.sizes);
    this.refs.filter.setSizes(this.sizes);

    this.widthes = _.reduce(this.products, function(result, prod) {
      return _.reduce(prod.variants, function(res, variant) {
        if (res.indexOf(variant.option3) < 0) res.push(variant.option3);
        return res;
      }, result);
    }, this.widthes);
    this.refs.filter.setWidthes(this.widthes);

    if (this.curRemaining.length) {
      jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).removeClass('hide');
    }
    setTimeout(this.checkToScroll, 100);
  },

  checkToScroll: function() {
    if (jQuery('#' + this.prodBackFrom).offset()) {

      setTimeout(function(){ jQuery(window).scroll(); }, 3000);
    } else {
      setTimeout(this.checkToScroll, 200);
    }
  },

  collectionGot: function(collection) {
    if (this.unmouned) return;
    this.allProductsGot = true;

    this.products = this.appendProducts(collection);

    if (this.curFilters) {
      this.handleFilter(this.curFilters);
    } else {
      this.curRemaining = this.curRemaining.concat(collection);
      if (this.showAllWhenLoaded) {
        var curDisplay = this.state.products;
        var i = curDisplay.length;
        var newRows = _.chunk(this.curRemaining, 3).map(function(threeProd) {
                          i++;
                          return <ProductRow collection={this.collection}
                                             products={threeProd}
                                             forBrand={this.forBrand}
                                             key={i} />}.bind(this));
    
        this.setState({ products: curDisplay.concat(newRows) });
      } else {
        if (this.curRemaining.length) {
          jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).removeClass('hide');
        }
      }
    }
    this.props.hideBlocker();
  },

  appendProducts: function(products) {

    this.sizes = _.reduce(products, function(result, prod) {
      return _.reduce(prod.variants, function(res, variant) {
        if (res.indexOf(variant.option2) < 0) res.push(variant.option2);
        return res;
      }, result);
    }, this.sizes);
    this.refs.filter.setSizes(this.sizes);

    this.widthes = _.reduce(products, function(result, prod) {
      return _.reduce(prod.variants, function(res, variant) {
        if (res.indexOf(variant.option3) < 0) res.push(variant.option3);
        return res;
      }, result);
    }, this.widthes);
    this.refs.filter.setWidthes(this.widthes);

    return this.products.concat(products);
  },

  setProductDivs: function(products) {
    var i = Math.floor(Math.random() * 10000);
    var first = 0;

    if (products.length) {
      var chunked = _.chunk(products, 3);
      var rows = chunked.map(function(threeProd) {
                   i++;
                   first++;
                   var containProdBackFrom = false;

                   if (this.backFromProd && _.some(threeProd, function(p) {
                                                                return p.handle == this.prodBackFrom;
                                                              }.bind(this))){
                     containProdBackFrom = true;
                   }

                   return <ProductRow collection={this.collection}
                                      products={threeProd}
                                      noFade={1 == first || containProdBackFrom}
                                      forBrand={this.forBrand}
                                      key={i} />}.bind(this));
      this.setState({ products: rows});
    } else {
      this.setState({ products: [] });
    }
  },

  loadAll: function() {
    if (!this.allProductsGot) {
      this.props.showBlocker();
      showAllWhenLoaded = true;
    } else {
      var i = 0;     
      var newRows = _.chunk(this.curRemaining, 3).map(function(threeProd) {
                          i++;
                          return <ProductRow collection={this.collection}
                                             products={threeProd}
                                             forBrand={this.forBrand}
                                             key={i} />}.bind(this));
      this.setState({ products: this.state.products.concat(newRows) });
    }
    jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).addClass('hide');
  },

  loadMore: function() {
    var toAdd = _.take(this.curRemaining, this.PRODUCT_PER_BATCH);

    this.curRemaining = this.curRemaining.slice(this.PRODUCT_PER_BATCH);

    var curDisplay = this.state.products;
    var i = curDisplay.length;
    var newRows = _.chunk(toAdd, 3).map(function(threeProd) {
                      i++;
                      return <ProductRow collection={this.collection}
                                         products={threeProd}
                                         forBrand={this.forBrand}
                                         key={i} />}.bind(this));
    
    this.setState({ products: curDisplay.concat(newRows) });

    if (!this.curRemaining.length) {
      jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).addClass('hide');
    }
  },

  collectionInfoGot: function(collInfo) {

    document.title = collInfo.title + " - Ingledew's Shoes";

    var collHtml = collInfo.description.replace("\n", '').replace("\r", '');
  	var post = Utils.reconstructPost(collHtml, false);
    var prefix = post.getByClass("prefix");
    var desc = post.getByClass("description");
    var image = collInfo.image ? collInfo.image.src : "";

    this.refs.breadcrumb.setSecondSeg({ text: collInfo.title} );
    this.refs.headerPage.setContent(prefix ? prefix.innerHTML : "",
                                    image,
                                    collInfo.title,
                                    desc ? desc.innerHTML : "");
    if (this.headerFull) {
      this.headerFull.setContent(collInfo.title, image);
    }
  },

  handleFilter: function(filters) {
    if (!this.allProductsGot) {
      this.curFilters = filters;
      this.props.showBlocker();
    }
    var filtered = _.clone(this.products);

    filtered = _.filter(filtered, function(prod) {

                 var heelPassed = true;
                 if (filters.heels.length) {
                   heelPassed = _.some(this.heels, function(heel) {
                                  return this.product_type.indexOf(heel) >= 0;
                                }, prod);
                 }
                 if (!heelPassed) return false;

                 var cswpPassed = _.some(prod.variants, function(variant) {

                   if (!variant.available) return false;

                   var colorPassed = true;
                   if (this.colors.length) {
                     colorPassed = _.some(this.colors, function(color) {
                                     var variantColor = variant.option1.split(' ')[0];
                                     return variantColor == color;
                                   });
                   }
                   
                   var sizePassed = true;
                   if (this.size.length) {
                     sizePassed = variant.option2 == this.size;
                   }

                   var widthPassed = true;
                   if (this.width.length) {
                     widthPassed = variant.option3 == this.width;
                   }

                   var pricePassed = true;
                   if (filters.price.lowerBound || filters.price.upperBound) {

                     pricePassed = parseFloat(variant.price) > this.price.lowerBound &&
                         (this.price.upperBound > 0 ? parseFloat(variant.price) < this.price.upperBound :
                                                       true);
                   }

                   return colorPassed && sizePassed && widthPassed && pricePassed;
                 }, this);

                 return cswpPassed;
               }, filters);
/*
    if (filters.heels.length) {

      filtered = _.filter(filtered, function(prod) {
    	             return _.some(this.heels, function(heel) {
    	               return this.product_type.indexOf(heel) >= 0;
    	             }, prod)
                 }, filters);
    }
    if (filters.colors.length) {
      filtered = _.filter(filtered, function(prod) {
                   return _.some(this.colors, function(color) {
                     var matched = _.some(this.variants, function(variant) {
                       var variantColor = variant.option1.split(' ')[0];
                       return variantColor == color;
                     });
                     return matched;
                   }, prod);
                 }, filters);
    }
    if (filters.size.length) {
    	filtered = _.filter(filtered, function(prod) {
    		           return _.some(prod.variants, function(variant) {
    		         	   return variant.option2 == this.size;
    		             }, this);
    	             }, filters);
    }
    if (filters.width.length) {
    	filtered = _.filter(filtered, function(prod) {
    		           return _.some(prod.variants, function(variant) {
    		         	   return variant.option3 == this.width;
    		           }, this);
    	           }, filters);
    }

    if (filters.price.lowerBound || filters.price.upperBound) {
      filtered = _.filter(filtered, function(prod) {
                   return parseFloat(prod.variants[0].price) > this.price.lowerBound &&
                          (this.price.upperBound > 0 ? parseFloat(prod.variants[0].price) < this.price.upperBound :
                                                       true);
                   }, filters);
    }
*/
    if (0 == filtered.length) {
      this.setState({ products: <p className="empty-result">No products meet your criteria.</p>});
      jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).addClass('hide');
      return;
    }

    var initialDisplayed = _.take(filtered, this.PRODUCT_PER_BATCH);
    var rest = filtered.slice(this.PRODUCT_PER_BATCH);

    this.curRemaining = rest;
    this.setProductDivs(initialDisplayed);
    if (this.curRemaining.length) {
      jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).removeClass('hide');
    } else {
      jQuery(ReactDOM.findDOMNode(this.refs.btnLoadMore)).addClass('hide');
    }
    setTimeout(function(){ jQuery(window).scroll(); }, 100);
    
  },

  render: function() {
    return <div>
        <Breadcrumb ref="breadcrumb" gender={this.props.params.gender}
                    className="hidden-xs" />
        <div className={"container breadcrumb-m hide"} ref="bcMobile">
            <Link to={"/collections/" + this.props.params.gender}>&lt; BACK TO COLLECTIONS</Link>
        </div>
        <HeaderPage ref="headerPage" pageName={this.props.params.gender}/>
        {this.state.headerFull}

        <main id="content" className="container" role="main">
            <FilterDiv changed={this.handleFilter} ref="filter" />
            <div ref="productRows">
              {this.state.products}
            </div>
            <div id="load-more-wrap">
               <button id="load-more" className="hide btn btn-primary"
                       onClick={this.loadAll} ref="btnLoadMore">
                  SEE ALL
               </button>
            </div>
        </main>
      </div>
  }
});